import React__default from 'react';
import { s as styleInject } from '../style-inject.es-746bb8ed.js';

var css_248z = ".TIyLn,.glob_fontElementMap{font-family:var(--ricos-font-family,unset)}._4JDnb{color:var(--ricos-settings-text-color,var(--ricos-text-color-low,#646464));font-family:var(--ricos-settings-text-font-family,Helvetica Neue,Helvetica,Arial);font-size:14px;line-height:20px}";
var styles = {"fontElementMap":"TIyLn","infoText":"_4JDnb"};
styleInject(css_248z);

const InfoText = ({ children, style }) => {
  return /* @__PURE__ */ React__default.createElement("div", { className: styles.infoText, style }, children);
};

export { InfoText as default };
//# sourceMappingURL=InfoText.js.map
